import React from "react";
import { BarChart3, CalendarDays, CheckCircle2, FileText, Flame, Sun } from "lucide-react";
import { bonuses } from "../data/content";
import { CollapsibleItem } from "./CollapsibleItem";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
const bonusIcons = [Flame, BarChart3, CalendarDays, FileText, Sun];
export function BonusesSection() {
  return <Reveal className="bg-[#0D1424] px-5 py-24 sm:px-8 lg:px-12" data-id="element-16" data-mp="14t2l9jdlldan">
      <div className="mx-auto max-w-[900px]" data-id="element-17" data-mp="14r7zk2ui5h5i">
        <SectionHeading title="Más los 5 Bonos Estratégicos" subtitle="Incluidos sin costo extra en la oferta completa." data-id="element-18" data-mp="zv9eao4h0f9b" />

        <div className="space-y-3" data-id="element-19" data-mp="1eiujqootiqke">
          {bonuses.map((bonus, index) => {
          const Icon = bonusIcons[index];
          const bullets = bonus.details ?? ["Incluido sin costo extra dentro de la oferta completa."];
          return <CollapsibleItem key={bonus.number} header={<div className="flex min-w-0 flex-1 items-center gap-4" data-id="element-21" data-mp="3pqlj4z9kf46t">
                    <div className="flex size-14 shrink-0 items-center justify-center rounded-xl border border-[#F5B83D]/15 bg-[#050B16]" data-id="element-22" data-mp="3psohc6kvg3mm">
                      <Icon className="size-6 text-[#F5B83D]" aria-hidden="true" data-id="element-23" data-mp="2lcny2sz9dqf" />
                    </div>
                    <div className="min-w-0 flex-1" data-id="element-24" data-mp="7lqlus0v77aq">
                      <div className="flex flex-wrap items-center gap-2" data-id="element-25" data-mp="7icl1o7un65e">
                        <span className="text-sm font-black uppercase tracking-wide text-[#F5B83D]" data-id="element-26" data-mp="cjjrnjy99zah">Bono {bonus.number}</span>
                        <span className="text-xs text-[#7C8AA0] line-through" data-id="element-27" data-mp="gj110ogszgkx">Valor: {bonus.value}</span>
                        <span className="rounded-full border border-[#27B36A]/30 bg-[#27B36A]/15 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-[#6EE7A8]" data-id="element-28" data-mp="qb6ygdptqq7i">
                          Gratis
                        </span>
                      </div>
                      <h3 className="mt-2 text-lg font-black leading-snug text-white sm:text-xl" style={{
                fontSize: "13px"
              }} data-id="element-29" data-mp="109mglr6vip4v">{bonus.title}</h3>
                      <p className="mt-1 text-sm leading-5 text-[#AAB7C8]" style={{
                fontSize: "13px"
              }} data-id="element-30" data-mp="5me7c5e7goyf">{bonus.description}</p>
                    </div>
                  </div>} data-id="element-20" data-mp="1jiqkmf27y1vq" data-mpi={index}>
                <div className="flex gap-4 px-5 pb-6 sm:px-6" data-id="element-31" data-mp="fjs8yyvgz96o">
                  <div className="w-14 shrink-0" aria-hidden="true" data-id="element-32" data-mp="fi8wzkgujkap" />
                  <div className="min-w-0 flex-1 space-y-2 border-t border-white/10 pt-4" data-id="element-33" data-mp="ta5i34k3ktxl">
                    {bullets.map(detail => <div key={detail} className="flex gap-2 text-sm leading-5 text-[#C7CED8]" data-id="element-34" data-mp="139wcz7cklay7">
                        <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-[#27B36A]" aria-hidden="true" data-id="element-35" data-mp="yatk0l9v6v6l" />
                        {detail}
                      </div>)}
                  </div>
                </div>
              </CollapsibleItem>;
        })}
        </div>
      </div>
    </Reveal>;
}